<template>
<div class="print">
        <table class="no-border" width="100%" border="0" cellspacing="0" cellpadding="0" style="border:none !important">
            <tr>
                <td align="left" width="60%">
                    <p class="bold">
                        ООО «Клиника Профессора»<br />
                        ИНН 1435316805, КПП 143501001, ОГРН 1171447001220<br />
                        Адрес: 677010, г. Якутск, ул. Радужная, 69/12<br />
                        Телефон: +7 (914)2776990; электронный адрес:<br />
                        klinika.professora@mail.ru
                    </p>
                </td>
                <td align="right" width="40%">
                    <p style="font-size:0.75rem">
                        Медицинская документация<br />
                        Учетная форма N 003/у<br />
                        Утверждена приказом Министерства<br />
                        здравоохранения Российской Федерации<br />
                        от 5 августа 2022 г. N 530н
                    </p>
                </td>
            </tr>
        </table>
        <table border="0" width="100%">
            <tr>
                <td style="width:50%">
                    {{hosvisit.clinimum}}
                </td>
                <td align="center">
                    <b>{{ medhistory.paid ? "ХРО" : "КСГ" }}</b><br/>
                    <b v-if="!medhistory.paid">Страховая организация: {{ patient.polis_issuer ? patient.polis_issuer : 'не указана' }}</b><br />
                    <b v-if="!medhistory.paid">Полис №: {{ patient.polis ? patient.polis : 'не указан' }} </b><br />
                    <b v-if="!medhistory.paid">СНИЛС №: {{ patient.snils ? patient.snils : 'не указан' }} </b><br />
                    Рост: {{ patient.height ? patient.height + ' см.' : 'не указан' }}, вес: {{ patient.weight ? patient.weight + ' кг.' : 'не указан' }}<br />
                </td>
            </tr>
        </table>
        <hr size=2 width="100%" align=center>
        <p style="text-align:center">
            <b>Медицинская карта пациента, <br/>получающего медицинскую помощь в стационарных условиях
            травматолого-ортопедического профиля №{{ title.medcard ? title.medcard : "_____" }}</b>
        </p>
        <h2 style="text-align:center">
            {{ patient.full_name }}
        </h2>
        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Пол:</b> {{ patient.sex === "m" ? "Мужской" : "Женский" }}, <b>национальность:</b> {{ patient.nation ? patient.nation : "не указана" }}, <b>образование:</b> {{ patient.education ? patient.education : "не указано"}} <br/>
            <b>Возраст:</b> {{ patientAge }} ({{ patient.birthdate.split('-').reverse().join('.')}} г.р.)<br/>
            <b>Постоянное место жительства:</b> {{ patient.address }}<br/>
            <b>Сведения о лице, которому может быть передана информация о состоянии здоровья пациента (Ф.И.О. родственника): :</b> {{ title.relative_full_name ? title.relative_full_name : "не указан" }}, <b>Телефон:</b> {{ title.relative_phone ? title.relative_phone : "не указан" }} <br/>
        </p>
        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Паспорт:</b> <span v-if="passport"> <b>серия:</b> {{ passport.series }}, <b>номер:</b> {{ passport.number }}, <b>выдан:</b> {{ passport.issued }}, {{ passport.date }} г.</span><span v-else>не указан</span><br/>
            <b>Место работы:</b> {{ patient.works ? patient.works : "не указано" }}<br/>
        </p>
        <hr size=2 width="100%" align=center>
            <b>Группа инвалидности:</b> {{ patient.disability }}
        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Дата и время поступления:</b> {{ medhistory.openDate }} в Ортопедическое отделение<br/>
            <b>Палата:</b> {{ medhistory.room }}<br/>
            <b>Дата и время выписки:</b> {{ medhistory.discharge_date }}<br/>
            <b>Проведено:</b> {{ discharge.clinic_days }}<br/>
        </p>
        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Вид транспортировки:</b> {{ title.transporting }}<br/>
            <b>Аллергические реакции</b> на лекарственные препараты, пищевая аллергия или иные виды непереносимости в анамнезе, с указанием типа и вида аллергической реакции: {{ hosvisit.status_alergo }} от {{ hosvisit.visitDate.split('')[0] }}, врач: {{ hosvisit.doctor_full_name }}<br/>
            <b>Трансфузии</b> (переливания) донорской крови и (или) ее компонентов (год, осложнения, реакции): {{ title.transfusions ? title.transfusions : 'не указано'}}<br/>
            <b>Группа крови и резус-принадлежность:</b> {{ patient.bloodtype ? bloodTypes[patient.bloodtype] : "не указано" }}, {{ patient.rhfactor ? rhfactor(patient.rhfactor) : "не указано" }} {{ patient.bloodtyping_date ? ', дата: ' + patient.bloodtyping_date : "" }}<br/>
            <b>Антиген K1, системы Kell, иные сведения групповой принадлежности крови (при наличии):</b> {{ patient.bloodantigen ? patient.bloodantigen : "не указано" }}<br/>
        </p>

        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Поступил(а) в стационар</b><br/>
            <b>Кем направлен пациент:</b> {{ title.referal }}<br/>
            <b>Доставлен в стационар:</b> Планово, <b>через 24 часа</b>, после начала заболевания<br/>
            <b>Номер и дата направления:</b> №{{ title.referal_id }} от {{ title.referal_date }}<br/>
            <b>Поступил(а)</b> в стационар для оказания медицинской помощи в текущем году: по поводу основного заболевания, указанного в диагнозе при поступлении: {{ title.multi ? 'повторно' : 'первично' }}<br/>
            <b>Форма оказания медицинской помощи:</b> плановая<br/>
            <b>Диагноз направившего учреждения:</b> {{ patient.diagnosis_first ? patient.diagnosis_first : "Нет" }}<br/>
            <b>Код МКБ:</b> {{ hosvisit.mkb10 }}<br/>
        </p>
        <hr size=2 width="100%" align=center>
        <p style="text-align:justify">
            <b>Диагноз при поступлении:</b> {{ hosvisit.diagnosis ? hosvisit.diagnosis : "Нет" }}<br/>
            <b>Код МКБ:</b> {{ hosvisit.mkb10 }}<br/>
            <b>Диагноз клинический:</b> {{ hosvisit.diagnosis ? hosvisit.diagnosis : "Нет" }}. <b>Дата установления клинического диагноза:</b> {{ hosvisit.visitDate.split(' ')[0] }}<br/>
            <b>Диагноз заключительный клинический:</b><br/>
            <b>Основной:</b> {{ discharge.diagnosis ? discharge.diagnosis : "Нет" }}<br/>
            <b>Осложнения основного диагноза:</b> {{ discharge.diagnosis_complication ? discharge.diagnosis_complication : "Нет"}}<br/>
            <b>Сопутствующий:</b> {{ discharge.diagnosis_secondary ? discharge.diagnosis_secondary : "Нет" }}<br/>
        </p>
        <hr size=2 width="100%" align=center>
            <b>Код МКБ:</b> {{ operation?.createDate ? operation.mkb10 : hosvisit.mkb10 }}<br/>
            <b>Дополнительные сведения о заболевании:</b>
        <hr size=2 width="100%" align=center>
            <div style="display:block;width:50%;float:left"><b>Врач:</b> {{ reduce(medhistory.doctor_full_name) }}</div>
            <div style="display:block;width:50%;margin-left:50%"><b>Заведующий отделением:</b> Пальшин В.Г.</div><br/>
        <p style="text-align:justify">
        <div class="pagebreak" />
            Хирургические операции, методы обезболивания и послеоперационные осложнения
        </p>
        <table>
            <tr>
                <th>
                    Операция
                </th>
                <th>
                    Дата
                </th>
                <th>
                    Наркоз
                </th>
                <th>
                    Осложнения
                </th>
                <th>
                    Хирург
                </th>
                <th>
                    Код операции
                </th>
                <th>
                    Код КСГ
                </th>
            </tr>
            <tr v-if="operation?.createDate">
                <td>
                    {{ operation.operationName }}
                </td>
                <td>
                    {{ operation.operationEnd.split(' ')[0] }}
                </td>
                <td>
                    {{ operation.anesthesia }}
                </td>
                <td>
                    {{ operation.complications }}
                </td>
                <td>
                    <text>{{ reduce(operation.operator_full_name) }}</text>
                    <text v-if="operation.assistOne"><br/>{{ reduce(operation.assistOne_full_name) }}</text>
                    <text v-if="operation.assistTwo"><br/>{{ reduce(operation.assistTwo_full_name) }}</text>
                </td>
                <td>
                    {{ operation.operationCode }}
                </td>
                <td>
                    {{ operation.operationCodeKSG }}
                </td>
            </tr>
        </table>
        <p style="text-align:justify">
            Другие виды лечения: {{ JSON.parse(title.cure_types).join(', ') }}<br/>
            Отметка о выдаче листка нетрудоспособности: {{ discharge.work_incapacity_cert }}<br/>
            Выдано направление на медико-социальную экспертизу (МСЭ): "__" ____ 20__ г.<br/><br/>
            Исход госпитализации: Выписан<br/>
            Результат госпитализации: {{ title.cure_result }}<br/>
            Трудоспособность: временно утрачена<br/>
            Для поступивших на экспертизу - заключение:<br/>
            Особые отметки:<br/>
            Критерии качества лечения<br/>
            Код МКБ: <b>{{ operation?.createDate ? operation.mkb10 : hosvisit.mkb10 }}</b><br/>
            Комментарий: {{ title.comment }}<br/>
        </p>
        <p style="text-align:center">
            Оценка уровня качества лечения (в баллах)
        </p>
        <table>
            <tr>
                <th>
                    Наименование критерия оценки
                </th>
                <th>
                    Оценка в норме
                </th>
                <th>
                    0 ступень (лечащий врач)
                </th>
                <th>
                    I ступень (заведующий отделением)
                </th>
                <th>
                    II ступень
                </th>
                <th>
                    III ступень
                </th>
            </tr>
            <tr>
                <td>
                    A. Сбор информации
                </td>
                <td>
                    4,0
                </td>
                <td>
                    4,0
                </td>
                <td>
                    4,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    B. Обоснование диагноза
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    C. Оценка лечебных мероприятий
                </td>
                <td>
                    2,0
                </td>
                <td>
                    2,0
                </td>
                <td>
                    2,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    D. Преемственность
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    E. Оформление документации
                </td>
                <td>
                    2,0
                </td>
                <td>
                    2,0
                </td>
                <td>
                    2,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    Сумма баллов
                </td>
                <td>
                    10,0
                </td>
                <td>
                    10,0
                </td>
                <td>
                    10,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                    УКЛ
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                    1,0
                </td>
                <td>
                </td>
                <td>
                </td>
            </tr>
        </table>
        <hr size=2 width="100%" align=center>
        <div style="display: flex;flex-direction: row;justify-content: space-between;">
            <div><b>Врач:</b><br/>{{ reduce(medhistory.doctor_full_name) }}</div>
            <div><b>Зав. отделением:</b><br/>Пальшин В.Г.</div>
            <div><b>Д.м.н. профессор:</b><br/>Пальшин Г.А.</div>
            <div><b>Главный врач:</b><br/>Устинова А.И.</div>
        </div>
        <div class="pagebreak" />
        <h2 style="text-align:center">
            СВЕДЕНИЯ О ПАЦИЕНТЕ
        </h2>
        <b>Фамилия, имя, отчество (при наличии) пациента:</b> {{ patient.full_name }}<br/>
        <b>Дата рождения:</b> {{ patient.birthdate.split('-').reverse().join('.')}} г.р. ({{ patientAge }})<br/>
        <b>Гражданство:</b> {{ patient.citizenship ? patient.citizenship : "не указано" }}<br/>
        <b>Документ, удостоверяющий личность:</b> паспорт: <span v-if="passport"> <b>серия:</b> {{ passport.series }}, <b>номер:</b> {{ passport.number }}, <b>выдан:</b> {{ passport.issued }}, {{ passport.date }} г.</span><span v-else>не указан</span><br/>
        <b>Номер телефона:</b> {{ patient.phone ? patient.phone : "не указан" }}<br/>
        <b>Адрес электронной почты:</b><br/>
        <b>Регистрация по месту жительства:</b> {{ patient.address ? patient.address : "не указан" }}<br/>
        <b>Регистрация по месту пребывания:</b> {{ patient.address ? patient.address : "не указан" }}<br/>
        <b>Местность:</b> {{ patient.villager ? "Сельская" : "Городская" }}<br/>
        <b>Семейное положение:</b> {{ patient.marriage ? patient.marriage : "не указано" }}<br/>
        <b>Общее образование:</b> {{ patient.education ? patient.education : "не указано"}}<br/>
        <b>Занятость:</b> {{ patient.employment }}<br/>
        <b>Должность (для работающего):</b> {{ patient.position ? patient.position : "не указана" }}<br/>
        <b>Группа инвалидности:</b> {{ patient.disability ? patient.disability : "не указана" }}<br/>
        <b>Лицо, подвергшееся радиационному облучению:</b> {{ patient.radiationstatus ? "Да" : "Нет" }}<br/>
        <b>Полис обязательного медицинского страхования:</b><br/>
        Полис №{{ patient.polis ? patient.polis : "не указан" }}, 
        дата выдачи полиса обязательного медицинского страхования: {{ patient.polis_date ? patient.polis_date : "не указана" }}<br/>
        данные о страховой медицинской организации, выбранной застрахованным лицом или определенной застрахованному лицу: {{ patient.polis_issuer ? patient.polis_issuer : "не указано" }}<br/>
        <b>СНИЛС:</b> {{ patient.snils ? patient.snils : "не указан" }}<br/>
        <b>Основной вид оплаты: </b>
        <span v-if="pay_method.length > 0" v-for="method, index in pay_method">{{ method + '' + (index < pay_method.length - 1 ? ', ' : '') }}</span>
        <span v-else>Не указан</span><br/>
        Сведения об ознакомлении с медицинской документацией:
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <hr size=2 width="100%" align=center style="margin-top:1.25rem">
        <div class="pagebreak" />
</div>
</template>
<script setup>
    import { bloodTypes, rhfactor } from "@/common/locale"
</script>
<script>
export default {
    props: ['patient'],
    methods: {
        reduce(string) {
            return string.split(' ')[0] + ' ' + string.split(' ')[1].substring(0,1) + '. ' + string.split(' ')[2].substring(0,1) + '.'
        },
    },
    computed: {
        pay_method(){
            return this.medhistory.pay_method ? JSON.parse(this.medhistory.pay_method) : []
        },
        patientAge() {
            var birthdate = new Date(this.patient.birthdate.split('.').reverse().join('-'))
            var today = new Date()
            return Math.floor((today-birthdate)/3600000/24/365)
        },
        medhistory() {
            return this.$store.state.app.medhistory
        },
        hosvisit() {
            return this.$store.state.app.hosvisit
        },
        discharge() {
            return this.$store.state.app.discharge
        },
        operation() {
            return this.$store.state.app.operation
        },
        title() {
            return this.$store.state.app.title
        },
        discharge() {
            return this.$store.state.app.de
        },
        passport() {
        if (this.$isJSON(this.patient.passport)) {
            let p = JSON.parse(this.patient.passport)
            if (p.series && p.number && p.issued && p.date) {
                // return 'серия ' + p.series + ' номер ' + p.number + ' выдан ' + p.issued + ' ' + p.date
                return p
            }else{
                return false
            }
        }else{
            return false
        }
      }
    }
}
</script>
<style scoped>
    .rc-table {
        border-collapse: collapse;
        border: solid 1px #333
    }
</style>
